import gql from "graphql-tag";

export default gql`
  mutation deleteCreditCommentary($id: String!) {
    deleteCreditCommentary(id: $id) {
      __typename
      id
      friendly_entity_id
      subject_type
      subject_id
      effective_time
      category
      detail
      current
      user
    }
  }
`;
